// extracted by mini-css-extract-plugin
module.exports = {"page":"rule-page_page__1-zgV"};